var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowers02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7c186;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-1",
    d: "M57.44,194.53l5.13-3.33a111.1,111.1,0,0,1,153.69,32.65h0l-5.13,3.33A111.1,111.1,0,0,1,57.44,194.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-1",
    d: "M234.1,79.78l5.13-3.33h0a111.11,111.11,0,0,1-32.65,153.69l-5.13,3.33h0A111.1,111.1,0,0,1,234.1,79.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14-2",
    className: "cls-1",
    d: "M197,205.44l5.13-3.33h0A111.1,111.1,0,0,1,169.49,355.8l-5.13,3.33h0A111.11,111.11,0,0,1,197,205.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15-2",
    className: "cls-1",
    d: "M187.33,211.73l5.13-3.33A111.1,111.1,0,0,1,346.15,241h0L341,244.38a111.1,111.1,0,0,1-153.69-32.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers02);
export default __webpack_public_path__ + "static/media/flowers-02.c1b6a69453e4f3d4dd291d62d226ab45.svg";
export { ForwardRef as ReactComponent };